var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwemix(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_624_2479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16Z",
    fill: "#8D91AB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.965 14.7129C27.0167 15.1483 27.0453 15.5923 27.0453 16.0435C27.0453 22.164 22.0776 27.1272 15.9484 27.1272C11.4856 27.1272 7.6394 24.496 5.87691 20.7016L7.65231 19.8092C9.08638 22.9561 12.2614 25.1433 15.9484 25.1433C20.9792 25.1433 25.0591 21.0697 25.0591 16.0435C25.0591 15.9504 25.0576 15.8573 25.0547 15.7642L26.965 14.7129ZM15.9484 4.95996C20.6221 4.95996 24.6218 7.84617 26.2565 11.9327L24.3578 12.5371C22.984 9.25273 19.7359 6.94378 15.9484 6.94378C10.9177 6.94378 6.83777 11.0174 6.83777 16.0435C6.83777 16.1051 6.83918 16.1681 6.84062 16.2297L4.98206 17.7481C4.89603 17.1923 4.85156 16.6236 4.85156 16.0435C4.853 9.92166 9.82063 4.95996 15.9484 4.95996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.58594 20.4752L14.439 11.6089L13.9887 15.2958L20.323 11.7106L20.0018 15.2112L28.3109 12.5686L17.0419 18.7679L17.8837 15.2399L11.373 19.0514L11.8032 16.3456L3.58594 20.4752Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_624_2479"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwemix);
export default __webpack_public_path__ + "static/media/twemix.482b376c8ba7470c21e1c74a2bc3bd9d.svg";
export { ForwardRef as ReactComponent };